import checkPhoneNumber from "./checkPhoneNumber";

const changeModalState = (selector) => {
    const windowForm = document.querySelectorAll('.balcon_icons_img '),
        windowWidth = document.querySelectorAll('#width'),
        windowHeight = document.querySelectorAll('#height'),
        windowType = document.querySelectorAll('#view_type'),
        windowProfile = document.querySelectorAll('.checkbox');

    checkPhoneNumber('#width');
    checkPhoneNumber('#height');

    function bindActionToElem(elem, event, prop) {
        elem.forEach((item, i) => {
            item.addEventListener(event, () => {
                switch (item.nodeName){
                    case "SPAN" :
                        selector[prop] = i;
                        break;

                    case "INPUT" :
                        if (item.getAttribute('type') === 'checkbox'){
                            i === 0 ? selector[prop] = "Холодное" : selector[prop] = "Теплое";
                            elem.forEach((box, j) => {
                                box.checked = false;
                                if (box === item) {box.checked = true;}
                            })
                        } else {
                            selector[prop] = item.value;
                        }
                        break;

                    case "SELECT" :
                        selector[prop] = item.value;
                        break;
                    }
                });


        });
    }

    bindActionToElem(windowForm, 'click', 'form');
    bindActionToElem(windowWidth, 'input', 'width');
    bindActionToElem(windowHeight, 'input', 'height');
    bindActionToElem(windowType, 'change', 'type');
    bindActionToElem(windowProfile, 'change', 'profile');
}

export default changeModalState;